var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpidLogoAnimationBlackZYbHBrkh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillRule: "nonzero"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.106 236c-33.726 0-61.509-11.284-83.348-34.127C49.92 179.167 39 150.957 39 117.38c0-33.715 10.92-61.65 32.62-83.942C93.32 11.146 120.965 0 154.83 0c33.725 0 61.231 11.284 82.38 34.265C258.356 57.108 269 85.18 269 118.895c0 33.439-10.643 61.373-31.79 83.666C216.06 224.716 188.831 236 155.105 236M0 393.345c0-36.864 14.623-67.408 43.498-91.783C72.558 277.188 109.577 265 155.296 265c45.163 0 81.997 12.338 110.132 37.465C293.748 327.593 308 358.287 308 395",
    style: {
      fill: "#000"
    },
    transform: "matrix(.68428 0 0 .74878 .605 1.253)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpidLogoAnimationBlackZYbHBrkh);
export default __webpack_public_path__ + "static/media/spid-logo-animation-black~ZYbHBrkh.6c392dfe92a8c551e0a968cdb545b33a.svg";
export { ForwardRef as ReactComponent };